let Share = {
	openWindow(url) {
		return window.open(url, 'Поделиться', 'width=640,height=480,location=no,toolbar=no,menubar=no');
	},
	facebook(url) {
		return this.openWindow(`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
	},
	vk(url) {
		return this.openWindow(`https://vk.com/share.php?url=${encodeURIComponent(url)}`);
	},
	google(url) {
		return this.openWindow(`https://plus.google.com/share?url=${encodeURIComponent(url)}`);
	},
	twitter(url) {
		return this.openWindow(`http://twitter.com/share?url=${encodeURIComponent(url)}`);
	},
	telegram(url) {
		return this.openWindow(`https://telegram.me/share/url?url=${encodeURIComponent(url)}`);
	},
	whatsapp(url) {
		return this.openWindow(`https://wa.me/?text=${encodeURIComponent(url)}`);
	},
};

$('.modal-more-container').on('click', '.sharing__item', (e) => {
	let url = location.href;

	switch ($(e.currentTarget).data('soc')) {
		case 'facebook':
			Share.facebook(url);
			break;
		case 'vk':
			Share.vk(url);
			break;
		case 'google':
			Share.google(url);
			break;
		case 'twitter':
			Share.twitter(url);
			break;
		case 'telegram':
			Share.telegram(url);
			break;
		case 'whatsapp':
			Share.whatsapp(url);
			break;
		default:
			break;
	}
});
